import { Link } from "react-router-dom";

export function LogoMark({ size = 32, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="klyroo-mark" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#00F0FF" />
          <stop offset="1" stopColor="#7000FF" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="44" height="44" rx="12" fill="#0B0E17" stroke="url(#klyroo-mark)" strokeWidth="2.5" />
      <path d="M17 12 v24" stroke="url(#klyroo-mark)" strokeWidth="4.5" strokeLinecap="round" />
      <path d="M33 12 L20 24 L33 36" stroke="url(#klyroo-mark)" strokeWidth="4.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="33" cy="24" r="3.2" fill="#00F0FF" />
    </svg>
  );
}

export function Logo({ to = "/", size = 32, showTag = false, className = "" }) {
  return (
    <Link to={to} data-testid="klyroo-logo" className={`flex items-center gap-2.5 group ${className}`}>
      <LogoMark size={size} className="transition-transform duration-300 group-hover:rotate-[-6deg]" />
      <div className="leading-none">
        <span className="font-display font-extrabold tracking-tight text-white" style={{ fontSize: size * 0.68 }}>
          KLYROO
        </span>
        {showTag && (
          <div className="overline mt-1 hidden sm:block">AI · Gaming · Technology</div>
        )}
      </div>
    </Link>
  );
}

export default Logo;
